import NextLink from "next/link";

function Link({ children, ...props }) {
  // Until we merge whole application to nextjs, we will have to use this component.
  return <a {...props}>{children}</a>;

  return <NextLink {...props}>{children}</NextLink>;
}

export default Link;
